import { createStore, produce } from 'solid-js/store'

export type ToastType = 'info' | 'success' | 'warning' | 'milestone' | 'danger'

export interface Toast {
  id: number
  message: string
  type: ToastType
  shareText?: string // Optional text to share
  duration: number // ms
  createdAt: number
}

interface ToastState {
  toasts: Toast[]
  nextId: number
}

const DEFAULT_DURATION = 5000

const [state, setState] = createStore<ToastState>({
  toasts: [],
  nextId: 1,
})

export const toastStore = {
  add: (message: string, type: ToastType = 'info', shareText?: string, duration: number = DEFAULT_DURATION) => {
    const id = state.nextId
    setState(produce(s => {
      s.toasts.push({
        id,
        message,
        type,
        shareText,
        duration,
        createdAt: Date.now(),
      })
      s.nextId++
    }))
    
    // Auto-remove after duration
    setTimeout(() => {
      toastStore.remove(id)
    }, duration)
    
    return id
  },

  remove: (id: number) => {
    setState(produce(s => {
      s.toasts = s.toasts.filter(t => t.id !== id)
    }))
  },

  clear: () => {
    setState({ toasts: [], nextId: state.nextId })
  },

  get toasts() {
    return state.toasts
  }
}

// Helper functions
export const toast = {
  info: (msg: string, shareText?: string) => toastStore.add(msg, 'info', shareText),
  success: (msg: string, shareText?: string) => toastStore.add(msg, 'success', shareText),
  warning: (msg: string, shareText?: string) => toastStore.add(msg, 'warning', shareText),
  milestone: (msg: string, shareText?: string) => toastStore.add(msg, 'milestone', shareText, 8000),
  danger: (msg: string, shareText?: string) => toastStore.add(msg, 'danger', shareText),
}
